<template>
  <div>
    <base-dialog
      @save-item="saveItem"
      @base-dialog-mounted="listCardModels(partner.id)"
      dialogId="edit-catalog-dialog"
      :form-ref.sync="catalogFormRef"
      :open.sync="openDialog"
      :loading.sync="isLoading"
      maxWidth="800"
    >
      <template v-slot:[`dialog.title`]>
        <span>Modifier un catalogue</span>
      </template>
      <template v-slot:[`dialog.content`]>
        <v-container>
          <catalog-form
            :catalog-form.sync="catalogForm"
            :cardModels="cardModels"
            :currenciesChoice="currenciesChoice"
            :catalogTypesChoice="catalogTypesChoice"
            :modesChoice="modesChoice"
            :reversionTypesChoice="reversionTypesChoice"
            :rules="rules"
          ></catalog-form>
        </v-container>
      </template>
      <template v-slot:[`dialog.actions.extra`]>
        <v-btn color="error" text @click="openDeleteDialog = true">
          Supprimer
        </v-btn>
      </template>
      <template v-slot:[`dialog.actions.close`]>Annuler</template>
      <template v-slot:[`dialog.actions.save`]>Enregistrer</template>
    </base-dialog>
    <delete-dialog
      :open.sync="openDeleteDialog"
      v-on:delete="triggerDeleteCatalog()"
    >
      <template #title> Suppression d'un catalogue</template>
      Vous êtes sur le point de supprimer ce catalogue. Voulez-vous continuer ?
    </delete-dialog>
    <loading-dialog v-if="openLoadingDialog">
      <template #loading-text>Suppression</template>
    </loading-dialog>
  </div>
</template>
<script>
import { toRefs, onMounted, computed, ref } from "@vue/composition-api";
import { useCatalogs } from "@/composables/catalog";
import { useCardModel } from "@/composables/card-model";
import CatalogForm from "@/components/Catalog/CatalogForm";
import BaseDialog from "@/components/General/BaseDialog.vue";
import DeleteDialog from "@/components/General/DeleteDialog.vue";
import LoadingDialog from "@/components/General/LoadingDialog.vue";

export default {
  components: {
    CatalogForm,
    BaseDialog,
    DeleteDialog,
    LoadingDialog,
  },
  props: {
    catalog: Object,
    partner: Object,
    open: Boolean,
  },
  setup(props, { emit }) {
    /* Import des API */
    const { catalogData, updateCatalog, deleteCatalog } = useCatalogs();
    const { cardModels, listCardModels } = useCardModel();

    /* Cycle de vie */
    onMounted(() => {
      catalogData.catalogForm = {
        price,
        reversion,
        currency,
        mode: mode.id,
        cardModel: cardModel.id,
        catalogType: catalogType.id,
        externalReference,
      };
      catalogData.catalogForm.reversionType =
        catalogData.reversionTypesChoice[0].value;
    });

    /* Variables */
    const {
      price,
      reversion,
      currency,
      mode,
      cardModel,
      catalogType,
      externalReference,
    } = props.catalog;
    const openDeleteDialog = ref(false);
    const openLoadingDialog = ref(false);

    /* Computed */
    const openDialog = computed({
      get: function () {
        return props.open;
      },
      set: function (value) {
        emit("update:open", value);
      },
    });

    /* Méthodes */
    const saveItem = async function () {
      await updateCatalog(props.catalog);
      openDialog.value = catalogData.editCatalogDialog;
    };
    const triggerDeleteCatalog = async function () {
      openLoadingDialog.value = true;
      await deleteCatalog(props.catalog);
      openLoadingDialog.value = false;
      openDeleteDialog.value = false;
      openDialog.value = false;
    };

    return {
      updateCatalog,
      ...toRefs(catalogData),
      cardModels,
      saveItem,
      listCardModels,
      openDialog,
      triggerDeleteCatalog,
      openLoadingDialog,
      openDeleteDialog,
    };
  },
};
</script>
